webpackJsonp([1],Array(19).concat([
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Loader_vue__ = __webpack_require__(69);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a8628e0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Loader_vue__ = __webpack_require__(156);
function injectStyle (ssrContext) {
  __webpack_require__(155)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7a8628e0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Loader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a8628e0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Loader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 20 */,
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dashboard_vue__ = __webpack_require__(41);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5c881c9f_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dashboard_vue__ = __webpack_require__(93);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dashboard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5c881c9f_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dashboard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Breadcrumb_vue__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_TopBar_vue__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_SideBar_vue__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(20);
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  components: {
    Breadcrumb: __WEBPACK_IMPORTED_MODULE_0__components_Breadcrumb_vue__["a" /* default */],
    TopBar: __WEBPACK_IMPORTED_MODULE_1__components_TopBar_vue__["a" /* default */],
    SideBar: __WEBPACK_IMPORTED_MODULE_2__components_SideBar_vue__["a" /* default */]
  },
  computed: Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapState */])(['currentUser'])
});

/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Breadcrumb_vue__ = __webpack_require__(36);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b9760f6e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Breadcrumb_vue__ = __webpack_require__(82);
function injectStyle (ssrContext) {
  __webpack_require__(81)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b9760f6e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Breadcrumb_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b9760f6e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Breadcrumb_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app-breadcrumb'
});

/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TopBar_vue__ = __webpack_require__(38);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b3def47_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TopBar_vue__ = __webpack_require__(84);
function injectStyle (ssrContext) {
  __webpack_require__(83)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TopBar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b3def47_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TopBar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_materialize_css__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_materialize_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_materialize_css__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app-top-bar',
  methods: {
    logout: function logout() {
      this.$store.commit('logout');
      this.$router.push({ name: 'login' });
    }
  },
  computed: {
    currentUser: function currentUser() {
      return this.$store.getters.currentUser;
    }
  },
  mounted: function mounted() {
    var elems = document.querySelectorAll('.dropdown-trigger');
    __WEBPACK_IMPORTED_MODULE_0_materialize_css__["Dropdown"].init(elems, {
      alignment: 'right'
    });
  }
});

/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_materialize_css__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_materialize_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_materialize_css__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app-side-bar',
  mounted: function mounted() {
    var elems = document.querySelectorAll('.sidenav');
    __WEBPACK_IMPORTED_MODULE_0_materialize_css__["Sidenav"].init(elems);

    elems = document.querySelectorAll('.collapsible');
    __WEBPACK_IMPORTED_MODULE_0_materialize_css__["Collapsible"].init(elems);
  }
});

/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_layouts_Dashboard__ = __webpack_require__(21);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'hello',
  data: function data() {
    return {
      msg: '¿Que deseas hacer?',
      object: [{
        icon: '<i class="fas fa-money-check"></i>',
        text: 'Generar Recibo de Pago',
        backgoundImage: '/static/img/button-background-01.png',
        backgoundColor: 'rgba(239, 83, 80, 0.8)',
        target: 'recibo'
      }, {
        icon: '<i class="fas fa-file-invoice"></i>',
        text: 'Generar Constancia de Trabajo',
        backgoundImage: '/static/img/button-background-02.png',
        backgoundColor: 'rgba(216, 67, 21, 0.8)',
        target: 'constancia'
      }, {
        icon: '<i class="fas fa-hand-holding-usd"></i>',
        text: 'Comprobante de retención ISLR<br><small>(En Construcción)</small>',
        backgoundImage: '/static/img/button-background-03.png',
        backgoundColor: 'rgba(174, 174, 174, 0.8)',
        target: 'home'
      }]
    };
  },
  mounted: function mounted() {
    document.title = 'RRHH Gobernación de Yaracuy';
  },

  components: {
    LayoutDashboard: __WEBPACK_IMPORTED_MODULE_0__components_layouts_Dashboard__["a" /* default */]
  }
});

/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Breadcrumb_vue__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_TopBar_vue__ = __webpack_require__(37);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    logout: function logout() {
      this.$store.commit('logout');
      this.$router.push('/login');
    }
  },
  components: {
    Breadcrumb: __WEBPACK_IMPORTED_MODULE_0__components_Breadcrumb_vue__["a" /* default */],
    TopBar: __WEBPACK_IMPORTED_MODULE_1__components_TopBar_vue__["a" /* default */]
  }
});

/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_layouts_Public__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_auth__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Loader__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config_json__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__config_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_validate_js__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_validate_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_validate_js__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      config: __WEBPACK_IMPORTED_MODULE_5__config_json___default.a,
      loaderStatus: false,
      form: {
        ci: '',
        password: ''
      },
      errors: {
        ci: false,
        password: false
      },
      error: null
    };
  },
  mounted: function mounted() {
    document.title = 'Ingresar al Sistema';
  },

  components: {
    LayoutPublic: __WEBPACK_IMPORTED_MODULE_1__components_layouts_Public__["a" /* default */],
    Loader: __WEBPACK_IMPORTED_MODULE_4__components_Loader__["a" /* default */]
  },
  methods: {
    authenticate: function authenticate() {
      var _this = this;

      // Validation
      this.errors = {
        ci: false,
        password: false
      };
      var constraints = this.getConstraints();
      var errors = __WEBPACK_IMPORTED_MODULE_6_validate_js___default()(this.form, constraints, { fullMessages: false });
      if (errors) {
        this.errors = errors;
        console.log(errors);
        return;
      }
      // Login Action
      this.loaderStatus = true;
      this.$store.dispatch('login');

      Object(__WEBPACK_IMPORTED_MODULE_3__helpers_auth__["b" /* login */])(this.$data.form).then(function (res) {
        _this.loaderStatus = false;
        _this.$store.commit('loginSuccess', res);
        _this.$router.push({ path: '/' });
      }).catch(function (error) {
        _this.loaderStatus = false;
        _this.$store.commit('loginFailed', { error: error });
      });
    },
    getConstraints: function getConstraints() {
      return {
        ci: {
          presence: {
            message: 'Es requerido',
            allowEmpty: false
          },
          numericality: {
            onlyInteger: true,
            message: 'Solo puede ingresar numeros'
          },
          length: {
            minimum: 6,
            maximum: 8,
            message: function message(value, attribute, validatorOptions, attributes, globalOptions) {
              return __WEBPACK_IMPORTED_MODULE_6_validate_js___default.a.format('Debe tener entre %{minimum} y %{maximum} digitos', {
                minimum: validatorOptions.minimum,
                maximum: validatorOptions.maximum
              });
            }
          }
        },
        password: {
          presence: {
            message: 'Es requerido',
            allowEmpty: false
          },
          length: {
            minimum: 6,
            message: 'Debe tener un minimo de 6 digitos'
          }
        }
      };
    },

    testDev: function testDev() {
      // this.form.email = 'admin@test.local'
      // this.form.password = 'admin'
      // document.getElementById('label-email').classList.add('active')
      // document.getElementById('label-password').classList.add('active')
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapState */])(['count']), {
    authError: function authError() {
      return this.$store.getters.authError;
    }
  })
});

/***/ }),
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Public_vue__ = __webpack_require__(53);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_951957ec_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Public_vue__ = __webpack_require__(109);
function injectStyle (ssrContext) {
  __webpack_require__(108)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-951957ec"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Public_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_951957ec_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Public_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = login;
/* harmony export (immutable) */ __webpack_exports__["a"] = getLocalUser;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__general__ = __webpack_require__(68);




function login(credentials) {
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_1_axios___default.a.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
    __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("https://api-rrhh.yaracuy.gob.ve" + '/api/auth/login', credentials).then(function (response) {
      Object(__WEBPACK_IMPORTED_MODULE_2__general__["b" /* setAuthorization */])(response.data.access_token);
      resolve(response.data);
    }).catch(function (err) {
      console.log('hubo un error');
      console.log(err);
      reject(err);
    });
  });
}

function getLocalUser() {
  var userStr = localStorage.getItem('user');

  if (!userStr) {
    return null;
  }

  return JSON.parse(userStr);
}

/***/ }),
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = initialize;
/* harmony export (immutable) */ __webpack_exports__["b"] = setAuthorization;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);



function initialize(store, router) {
  router.beforeEach(function (to, from, next) {
    var requiresAuth = to.matched.some(function (record) {
      return record.meta.requiresAuth;
    });
    var currentUser = store.state.currentUser;

    if (requiresAuth && !currentUser) {
      // En caso de login ser requerido y no estarlo
      next({ name: 'login' });
    } else if (!to.matched.length) {
      // En caso que la ruta no exista
      next({ name: 'home' });
    } else if (to.name === 'login' && currentUser) {
      // En caso de ir a login estando logueado
      next({ name: 'home' });
    } else {
      // En el resto de los casos
      next();
    }
  });

  __WEBPACK_IMPORTED_MODULE_1_axios___default.a.interceptors.response.use(null, function (error) {
    if (error.response.status === 401) {
      store.commit('logout');
      router.push({ name: 'login' });
    }

    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
  });

  if (store.getters.currentUser) {
    setAuthorization(store.getters.currentUser.token);
  }
}

function setAuthorization(token) {
  __WEBPACK_IMPORTED_MODULE_1_axios___default.a.defaults.headers.common['Authorization'] = 'Bearer ' + token;
}

/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['show'],
  watch: {
    show: function show(val) {
      if (val) {
        document.documentElement.style.overflow = 'hidden'; // firefox, chrome
        document.body.scroll = 'no'; // ie only
      } else {
        document.documentElement.style.overflow = ''; // firefox, chrome
        document.body.scroll = 'yes'; // ie only
      }
    }
  },
  destroyed: function destroyed() {
    document.documentElement.style.overflow = ''; // firefox, chrome
    document.body.scroll = 'yes'; // ie only
  }
});

/***/ }),
/* 70 */,
/* 71 */,
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_layouts_Public__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_validate_js__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_validate_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_validate_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Loader__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_materialize_css__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_materialize_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_materialize_css__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      loaderStatus: false,
      form: {
        name: '',
        ci: '',
        email: '',
        password: '',
        password_confirmation: ''
      },
      errors: {
        name: false,
        ci: false,
        email: false,
        password: false,
        password_confirmation: false
      },
      error: null
    };
  },
  mounted: function mounted() {
    document.title = 'Registro';
  },

  components: {
    LayoutPublic: __WEBPACK_IMPORTED_MODULE_0__components_layouts_Public__["a" /* default */],
    Loader: __WEBPACK_IMPORTED_MODULE_3__components_Loader__["a" /* default */]
  },
  methods: {
    register: function register() {
      var _this = this;

      this.errors = {
        name: false,
        ci: false,
        email: false,
        password: false,
        password_confirmation: false
      };
      var constraints = this.getConstraints();
      var errors = __WEBPACK_IMPORTED_MODULE_2_validate_js___default()(this.form, constraints, { fullMessages: false });
      if (errors) {
        this.errors = errors;
        return;
      }
      this.loaderStatus = true;
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("https://api-rrhh.yaracuy.gob.ve" + '/api/auth/register', this.form).then(function (response) {
        _this.loaderStatus = false;
        _this.$router.push('/dashboard');
        __WEBPACK_IMPORTED_MODULE_4_materialize_css__["toast"]({ html: '<span>Su <strong>registro</strong> fue completado con éxito, puede iniciar sessión</span>', classes: 'teal lighten-2' });
      }).catch(function (err) {
        _this.loaderStatus = false;
        // err.response.data.message
        _this.errors = err.response.data.errors;
        // console.log(['hubo un error', err.response.data])
        __WEBPACK_IMPORTED_MODULE_4_materialize_css__["toast"]({ html: 'Ocurrio un error al guardar el formulario', classes: 'red' });
      });
      // axios.interceptors.response.use(
      //   (response) => {
      //     this.loaderStatus = false
      //     console.log(response)
      //   },
      //   (error) => {
      //     this.loaderStatus = false
      //     console.log(error)
      //     return Promise.reject(error.response)
      //   }
      // )
    },
    getConstraints: function getConstraints() {
      return {
        name: {
          presence: {
            message: 'Es requerido',
            allowEmpty: false
          }
        },
        ci: {
          presence: {
            message: 'Es requerido',
            allowEmpty: false
          },
          numericality: {
            onlyInteger: true,
            message: 'Solo puede ingresar numeros'
          },
          length: {
            minimum: 6,
            maximum: 8,
            message: function message(value, attribute, validatorOptions, attributes, globalOptions) {
              return __WEBPACK_IMPORTED_MODULE_2_validate_js___default.a.format('Debe tener entre %{minimum} y %{maximum} digitos', {
                minimum: validatorOptions.minimum,
                maximum: validatorOptions.maximum
              });
            }
          }
        },
        email: {
          presence: {
            message: 'Es requerido',
            allowEmpty: false
          },
          email: {
            message: 'Debe ingresar un Correo electronico'
          }
        },
        password: {
          presence: {
            message: 'Es requerido',
            allowEmpty: false
          },
          length: {
            minimum: 6,
            message: 'Debe tener un minimo de 6 digitos'
          }
        },
        password_confirmation: {
          equality: {
            attribute: 'password',
            message: 'Las claves no coinciden'
          }
        }
      };
    }
  },
  computed: {
    authError: function authError() {
      return this.$store.getters.authError;
    }
  }
});

/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_layouts_Dashboard__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_materialize_css__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_materialize_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_materialize_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Loader__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'hello',
  data: function data() {
    return {
      nominas: this.$store.getters.currentUser.nominas,
      recibo: {
        blob: null,
        filename: null
      },
      loaderStatus: false,
      form: {
        nomina: 0,
        year: null,
        month: null,
        sendemail: false
      }
    };
  },

  components: {
    LayoutDashboard: __WEBPACK_IMPORTED_MODULE_0__components_layouts_Dashboard__["a" /* default */],
    Loader: __WEBPACK_IMPORTED_MODULE_2__components_Loader__["a" /* default */]
  },
  methods: {
    loadFormSelect: function loadFormSelect() {
      var elems = document.querySelectorAll('select');
      var options = document.querySelectorAll('option');
      __WEBPACK_IMPORTED_MODULE_1_materialize_css__["FormSelect"].init(elems, options);
    },
    generarRecibo: function generarRecibo() {
      var elems = document.getElementById('generar-recibo');
      var instance = __WEBPACK_IMPORTED_MODULE_1_materialize_css__["Modal"].init(elems);
      instance.open();
    },
    generarReciboConfirm: function generarReciboConfirm() {
      var _this = this;

      var elems = document.getElementById('generar-recibo');
      var instance = __WEBPACK_IMPORTED_MODULE_1_materialize_css__["Modal"].init(elems);
      instance.close();

      this.loaderStatus = true;
      var values = {
        // nomina: this.$store.getters.currentUser.nominas[this.form.nomina].tipo_nomina,
        nomina: this.form.nomina,
        year: this.form.year,
        month: this.form.month,
        sendemail: this.form.sendemail
      };
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("https://api-rrhh.yaracuy.gob.ve" + '/api/recibo', values, {
        responseType: 'blob'
      }).then(function (response) {
        elems = document.getElementById('descargar-recibo');
        var options = {
          onCloseEnd: function onCloseEnd() {
            document.documentElement.style.overflow = ''; // firefox, chrome
            document.body.style.overflow = '';
            document.body.scroll = 'yes'; // ie only
          }
        };
        instance = __WEBPACK_IMPORTED_MODULE_1_materialize_css__["Modal"].init(elems, options);
        instance.open();

        _this.loaderStatus = false;

        _this.recibo.filename = 'recibo-' + values.nomina + '-' + values.month + '.pdf';
        var blob = new Blob([response.data], { type: 'application/pdf' });
        var link = document.getElementById('linkdownload');
        link.href = window.URL.createObjectURL(blob);
        link.download = _this.recibo.filename;
      }).catch(function (err) {
        _this.loaderStatus = false;
        // err.response.data.message
        _this.errors = err.response.data.errors;
        // console.log(['hubo un error', err.response.data])
        __WEBPACK_IMPORTED_MODULE_1_materialize_css__["toast"]({ html: 'Ocurrio un error al guardar el formulario', classes: 'red' });
      });
    }
  },
  computed: {
    years: function years() {
      var years = [];
      for (var key in this.nominas[this.form.nomina].years) {
        years.unshift(key);
      }
      // console.log(this.nominas[this.form.nomina].years)
      this.form.year = years[0];
      return years;
    },
    months: function months() {
      this.form.month = null;
      if (this.nominas[this.form.nomina].years[this.form.year] != null) {
        this.form.month = this.nominas[this.form.nomina].years[this.form.year][0].fecha_p_hasta;
        // console.log(this.nominas[this.form.nomina].years[this.form.year][0].mm)
      }
      return this.nominas[this.form.nomina].years[this.form.year];
    },
    button: function button() {
      if (this.$store.getters.currentUser.nominas[this.form.nomina].tipo_nomina && this.form.year && this.form.month) {
        return false;
      }
      return true;
    }
  },
  mounted: function mounted() {
    document.title = 'Recibos de Pago';
  },
  updated: function updated() {
    this.loadFormSelect();
  }
});

/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_layouts_Dashboard__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_materialize_css__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_materialize_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_materialize_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Loader__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'constancia',
  data: function data() {
    return {
      nominas: this.$store.getters.currentUser.nominas,
      constancia: {
        blob: null,
        filename: null
      },
      loaderStatus: false,
      form: {
        nomina: 0,
        tipo: 'basico',
        sendemail: false
      }
    };
  },

  components: {
    LayoutDashboard: __WEBPACK_IMPORTED_MODULE_0__components_layouts_Dashboard__["a" /* default */],
    Loader: __WEBPACK_IMPORTED_MODULE_2__components_Loader__["a" /* default */]
  },
  methods: {
    loadFormSelect: function loadFormSelect() {
      var elems = document.querySelectorAll('select');
      var options = document.querySelectorAll('option');
      __WEBPACK_IMPORTED_MODULE_1_materialize_css__["FormSelect"].init(elems, options);
    },
    generarRecibo: function generarRecibo() {
      var elems = document.getElementById('generar-recibo');
      var instance = __WEBPACK_IMPORTED_MODULE_1_materialize_css__["Modal"].init(elems);
      instance.open();
    },
    generarReciboConfirm: function generarReciboConfirm() {
      var _this = this;

      var elems = document.getElementById('generar-recibo');
      var instance = __WEBPACK_IMPORTED_MODULE_1_materialize_css__["Modal"].init(elems);
      instance.close();

      this.loaderStatus = true;
      var values = {
        // nomina: this.$store.getters.currentUser.nominas[this.form.nomina].tipo_nomina,
        nomina: this.form.nomina,
        tipo: this.form.tipo,
        sendemail: this.form.sendemail
      };
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("https://api-rrhh.yaracuy.gob.ve" + '/api/constancia', values, {
        responseType: 'blob'
      }).then(function (response) {
        elems = document.getElementById('descargar-recibo');
        var options = {
          onCloseEnd: function onCloseEnd() {
            document.documentElement.style.overflow = ''; // firefox, chrome
            document.body.style.overflow = '';
            document.body.scroll = 'yes'; // ie only
          }
        };
        instance = __WEBPACK_IMPORTED_MODULE_1_materialize_css__["Modal"].init(elems, options);
        instance.open();

        _this.loaderStatus = false;

        _this.constancia.filename = 'recibo-' + values.nomina + '-' + values.month + '.pdf';
        var blob = new Blob([response.data], { type: 'application/pdf' });
        var link = document.getElementById('linkdownload');
        link.href = window.URL.createObjectURL(blob);
        link.download = _this.constancia.filename;
      }).catch(function (err) {
        _this.loaderStatus = false;
        // err.response.data.message
        _this.errors = err.response.data.errors;
        // console.log(['hubo un error', err.response.data])
        __WEBPACK_IMPORTED_MODULE_1_materialize_css__["toast"]({ html: 'Ocurrio un error al guardar el formulario', classes: 'red' });
      });
    }
  },
  computed: {
    button: function button() {
      return false;
    }
  },
  mounted: function mounted() {
    document.title = 'Constancia de Trabajo';
    this.loadFormSelect();
  },
  updated: function updated() {
    this.loadFormSelect();
  }
});

/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_general__ = __webpack_require__(68);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.



// -----------------

// import axios from 'axios'




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* default */]);
var store = new __WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* default */].Store(__WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */]);
Object(__WEBPACK_IMPORTED_MODULE_5__helpers_general__["a" /* initialize */])(store, __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */]);
// -----------------

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  store: store,
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] }
});

/***/ }),
/* 76 */,
/* 77 */,
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(34);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a7d21462_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(88);
function injectStyle (ssrContext) {
  __webpack_require__(79)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a7d21462_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 79 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 80 */,
/* 81 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"grey lighten-5"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"nav-wrapper"},[_c('a',{staticClass:"breadcrumb",staticStyle:{"margin-left":"20px"},attrs:{"href":"#!"}},[_vm._v("Admin")]),_vm._v(" "),_c('a',{staticClass:"breadcrumb",attrs:{"href":"#!"}},[_vm._v("Index")]),_vm._v(" "),_c('div',{staticClass:"right",staticStyle:{"margin-right":"20px"},attrs:{"id":"timestamp"}})])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 83 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navbar-fixed"},[_c('nav',{staticClass:"navbar red darken-1",attrs:{"role":"navigation"}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"nav-wrapper"},[_c('router-link',{staticClass:"brand-logo",attrs:{"id":"logo-container","to":"/"}},[_c('img',{staticClass:"responsive-img",staticStyle:{"max-height":"60px","margin":"2px"},attrs:{"src":"/static/img/logoyaracuy2.png","alt":""}})]),_vm._v(" "),_c('ul',{staticClass:"right"},[_c('li',[_vm._m(0),_vm._v(" "),_c('ul',{staticClass:"dropdown-content",attrs:{"id":"dropdown1"}},[_vm._m(1),_vm._v(" "),_c('li',{staticClass:"divider"}),_vm._v(" "),_c('li',[_c('a',{staticClass:"dropdown-item",attrs:{"href":"#!"},on:{"click":function($event){$event.preventDefault();return _vm.logout($event)}}},[_vm._v("Salir")])])])])])],1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"dropdown-trigger",attrs:{"href":"#!","data-target":"dropdown1"}},[_c('i',{staticClass:"material-icons right"},[_vm._v("account_circle")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',[_c('a',{attrs:{"href":"#!"}},[_vm._v("Perfil")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SideBar_vue__ = __webpack_require__(39);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7316bcd7_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SideBar_vue__ = __webpack_require__(87);
function injectStyle (ssrContext) {
  __webpack_require__(86)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SideBar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7316bcd7_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SideBar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 86 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"sidenav sidenav-fixed",attrs:{"id":"slide-out"}},[_c('li',{staticClass:"indigo"},[_c('div',{staticClass:"user-view"},[_c('a',{attrs:{"href":"#user"}},[_c('img',{staticClass:"circle",attrs:{"src":"https://materializecss.com/images/yuna.jpg"}})]),_vm._v(" "),_c('a',{attrs:{"href":"#name"}},[_c('span',{staticClass:"white-text name"},[_vm._v("John Doe")])]),_vm._v(" "),_c('a',{attrs:{"href":"#email"}},[_c('span',{staticClass:"white-text email"},[_vm._v("jdandturk@gmail.com")])])])]),_vm._v(" "),_c('li',[_c('ul',{staticClass:"collapsible",attrs:{"data-collapsible":"accordion"}},[_c('li',{},[_c('a',{staticClass:"waves-effect",attrs:{"href":"#"}},[_vm._v("\n          Dashboard\n          "),_c('i',{staticClass:"fas fa-tachometer-alt"})])]),_vm._v(" "),_c('li',{},[_c('a',{staticClass:"collapsible-header waves-effect"},[_vm._v("\n          Configuration\n          "),_c('i',{staticClass:"material-icons"},[_vm._v("settings")])]),_vm._v(" "),_c('div',{staticClass:"collapsible-body",staticStyle:{"display":"none","padding-top":"0px","margin-top":"0px","padding-bottom":"0px","margin-bottom":"0px"}},[_c('ul',[_c('li',[_c('a',{staticClass:"waves-effect",staticStyle:{"text-decoration":"none"},attrs:{"href":"#!"}},[_vm._v("Seller")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"waves-effect",staticStyle:{"text-decoration":"none"},attrs:{"href":"#!"}},[_vm._v("Customer")])])])])]),_vm._v(" "),_c('li',{},[_c('a',{staticClass:"collapsible-header waves-effect"},[_vm._v("\n          Configuration\n          "),_c('i',{staticClass:"material-icons"},[_vm._v("settings")])]),_vm._v(" "),_c('div',{staticClass:"collapsible-body",staticStyle:{"display":"none","padding-top":"0px","margin-top":"0px","padding-bottom":"0px","margin-bottom":"0px"}},[_c('ul',[_c('li',[_c('a',{staticClass:"waves-effect",staticStyle:{"text-decoration":"none"},attrs:{"href":"#!"}},[_vm._v("Seller")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"waves-effect",staticStyle:{"text-decoration":"none"},attrs:{"href":"#!"}},[_vm._v("Customer")])])])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('main',[_c('router-view')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Hello__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_auth_Login__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_auth_Register__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_RRHH_Recibo__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_RRHH_Constancia__ = __webpack_require__(166);







__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'home',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Hello__["a" /* default */],
    meta: {
      requiresAuth: true
      /* ,
      children: [
        {
          path: '/',
          component: CustomersList
        },
        {
          path: 'new',
          component: NewCustomer
        },
        {
          path: ':id',
          component: Customer
        }
      ] */
    } }, {
    path: '/recibo',
    name: 'recibo',
    component: __WEBPACK_IMPORTED_MODULE_5__components_RRHH_Recibo__["a" /* default */],
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/constancia',
    name: 'constancia',
    component: __WEBPACK_IMPORTED_MODULE_6__components_RRHH_Constancia__["a" /* default */],
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/ingresar',
    name: 'login',
    component: __WEBPACK_IMPORTED_MODULE_3__components_auth_Login__["a" /* default */]
  }, {
    path: '/registro',
    name: 'register',
    component: __WEBPACK_IMPORTED_MODULE_4__components_auth_Register__["a" /* default */]
  }],
  mode: 'history'
}));

/***/ }),
/* 90 */,
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Hello_vue__ = __webpack_require__(40);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_864b7a52_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Hello_vue__ = __webpack_require__(94);
function injectStyle (ssrContext) {
  __webpack_require__(92)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-864b7a52"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Hello_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_864b7a52_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Hello_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 92 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('header',[_c('top-bar')],1),_vm._v(" "),_c('div',{staticClass:"container"},[_vm._t("default")],2),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('footer',{staticClass:"page-footer grey darken-2"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"col l4 s12"},[_c('h5',{staticClass:"white-text"},[_vm._v("Acciones")]),_vm._v(" "),_c('ul',[_vm._m(2),_vm._v(" "),_vm._m(3),_vm._v(" "),_vm._m(4),_vm._v(" "),_c('li',[_c('a',{staticClass:"grey-text text-lighten-3",attrs:{"href":"#!"},on:{"click":function($event){$event.preventDefault();return _vm.logout($event)}}},[_c('i',{staticClass:"fas fa-sign-out-alt"}),_vm._v(" Salir del Sistema")])])])]),_vm._v(" "),_vm._m(5)])]),_vm._v(" "),_vm._m(6)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"headband"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s6 left-align"},[_c('img',{staticClass:"responsive-img",attrs:{"src":"/static/img/headband-a.png","alt":""}})]),_vm._v(" "),_c('div',{staticClass:"col s6 right-align"},[_c('img',{staticClass:"responsive-img",attrs:{"src":"/static/img/headband-b.png","alt":""}})])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col l4 s12"},[_c('h5',{staticClass:"white-text"},[_vm._v("Sistema RRHH")]),_vm._v(" "),_c('p',{staticClass:"grey-text text-lighten-4"},[_vm._v("Sistema diseñado para facilitar y agilizar tramites del departamento de "),_c('strong',[_vm._v("Recursos Humano")]),_vm._v(".")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',[_c('a',{staticClass:"grey-text text-lighten-3",attrs:{"href":"#!"}},[_c('i',{staticClass:"fas fa-user-circle"}),_vm._v(" Editar Perfil")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',[_c('a',{staticClass:"grey-text text-lighten-3",attrs:{"href":"#!"}},[_c('i',{staticClass:"fas fa-key"}),_vm._v(" Cambiar Contraseña")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',[_c('a',{staticClass:"grey-text text-lighten-3",attrs:{"href":"#!"}},[_c('i',{staticClass:"fas fa-comments"}),_vm._v(" Enviar un mensaje")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col l4 s12"},[_c('h5',{staticClass:"white-text"},[_vm._v("Enlaces de Interes")]),_vm._v(" "),_c('ul',[_c('li',[_c('a',{staticClass:"grey-text text-lighten-3",attrs:{"target":"_blank","href":"#!"}},[_c('i',{staticClass:"fas fa-check"}),_vm._v(" Gobierno de Yaracuy")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"grey-text text-lighten-3",attrs:{"target":"_blank","href":"http://www.inces.gob.ve/wp-content/uploads/2017/10/lot.pdf"}},[_c('i',{staticClass:"fas fa-check"}),_vm._v(" LOTTT")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"grey-text text-lighten-3",attrs:{"target":"_blank","href":"#!"}},[_c('i',{staticClass:"fas fa-check"}),_vm._v(" Contraloría")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"grey-text text-lighten-3",attrs:{"target":"_blank","href":"#!"}},[_c('i',{staticClass:"fas fa-check"}),_vm._v(" Seguro Social")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer-copyright grey darken-3"},[_c('div',{staticClass:"container"},[_vm._v("\n        Gobernación del estado Bolivariano de Yaracuy\n        |\n        Desarrollado por\n        "),_c('a',{staticClass:"orange-text text-lighten-3",attrs:{"href":"http://materializecss.com"}},[_vm._v("Alfonzo Diez")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('layout-dashboard',[_c('h1',{staticClass:"header center grey-text text-darken-3"},[_vm._v(_vm._s(_vm.msg))]),_vm._v(" "),_c('div',{staticClass:"row"},_vm._l((_vm.object),function(item,index){return _c('router-link',{key:index,staticClass:"col s12 m6",attrs:{"to":{ name: item.target }}},[_c('div',{staticClass:"card button-action-card hoverable",style:({'background-image': 'url(' + item.backgoundImage + ')'})},[_c('div',{staticClass:"row button-action-row waves-effect waves-block waves-light",style:({'background-color': item.backgoundColor})},[_c('div',{staticClass:"col s4 center button-action-icon",domProps:{"innerHTML":_vm._s(item.icon)}}),_vm._v(" "),_c('div',{staticClass:"col s8 center button-action-text",domProps:{"innerHTML":_vm._s(item.text)}})])])])}),1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__(42);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5aba347e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__(159);
function injectStyle (ssrContext) {
  __webpack_require__(96)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5aba347e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5aba347e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 96 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('nav',{staticClass:"navbar deep-orange darken-2",attrs:{"role":"navigation"}}),_vm._v(" "),_c('section',{staticClass:"section-login"},[_c('div',{staticClass:"section-login-overlay"}),_vm._v(" "),_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"col s12 m7 offset-m1"},[_vm._t("default")],2)])])]),_vm._v(" "),_c('footer',{staticClass:"page-footer grey darken-2"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row actions"},[_c('div',{staticClass:"col s12 m6 l3 center-align"},[_c('router-link',{staticClass:"btn yellow darken-4 waves-effect",attrs:{"to":{ name: 'login' }}},[_vm._v("Ingresar")]),_vm._v(" "),_c('div',{staticClass:"info"},[_vm._v("Si ya te encuentras registra solo debes ingresar tu información de acceso")])],1),_vm._v(" "),_c('div',{staticClass:"col s12 m6 l3 center-align"},[_c('router-link',{staticClass:"btn blue darken-3 waves-effect",attrs:{"to":{ name: 'register' }}},[_vm._v("Registrarse")]),_vm._v(" "),_vm._m(2)],1),_vm._v(" "),_vm._m(3),_vm._v(" "),_vm._m(4)])]),_vm._v(" "),_vm._m(5)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"headband"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s6 left-align"},[_c('img',{staticClass:"responsive-img",attrs:{"src":"/static/img/headband-a.png","alt":""}})]),_vm._v(" "),_c('div',{staticClass:"col s6 right-align"},[_c('img',{staticClass:"responsive-img",attrs:{"src":"/static/img/headband-b.png","alt":""}})])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col s6 offset-s3 m4"},[_c('div',{staticClass:"aside-info"},[_c('img',{staticClass:"responsive-img",attrs:{"src":"/static/img/logoyaracuy.svg","alt":""}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"info"},[_vm._v("Solo necesitas tener un\n            "),_c('strong',[_vm._v("Correo Electrónico")]),_vm._v(" activo para completar el registro.\n          ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col s12 m6 l3 center-align"},[_c('a',{staticClass:"btn blue darken-3 waves-effect"},[_vm._v("Recupera Contraseña")]),_vm._v(" "),_c('div',{staticClass:"info"},[_vm._v("Si olvidaste la contraseña puede recuperarla haciendo uso de algún dato de contacto aportado durante el registro o actualizado en el perfil.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col s12 m6 l3 center-align"},[_c('a',{staticClass:"btn blue darken-3 waves-effect"},[_vm._v("Reiniciar Registro")]),_vm._v(" "),_c('div',{staticClass:"info"},[_vm._v("Si por Alguna razon olvidaste todos tus datos con los que te registraste y no tienes acceso al\n            "),_c('strong',[_vm._v("Correo Electrónico")]),_vm._v(" puedes reiniciar tu registro.\n          ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer-copyright grey darken-3"},[_c('div',{staticClass:"container"},[_vm._v("\n        Gobernación del estado Bolivariano de Yaracuy\n        ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],attrs:{"id":"loading-element"}},[_vm._m(0)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"center-align"},[_c('div',{staticClass:"preloader-wrapper big active"},[_c('div',{staticClass:"spinner-layer spinner-blue"},[_c('div',{staticClass:"circle-clipper left"},[_c('div',{staticClass:"circle"})]),_c('div',{staticClass:"gap-patch"},[_c('div',{staticClass:"circle"})]),_c('div',{staticClass:"circle-clipper right"},[_c('div',{staticClass:"circle"})])]),_vm._v(" "),_c('div',{staticClass:"spinner-layer spinner-red"},[_c('div',{staticClass:"circle-clipper left"},[_c('div',{staticClass:"circle"})]),_c('div',{staticClass:"gap-patch"},[_c('div',{staticClass:"circle"})]),_c('div',{staticClass:"circle-clipper right"},[_c('div',{staticClass:"circle"})])]),_vm._v(" "),_c('div',{staticClass:"spinner-layer spinner-yellow"},[_c('div',{staticClass:"circle-clipper left"},[_c('div',{staticClass:"circle"})]),_c('div',{staticClass:"gap-patch"},[_c('div',{staticClass:"circle"})]),_c('div',{staticClass:"circle-clipper right"},[_c('div',{staticClass:"circle"})])]),_vm._v(" "),_c('div',{staticClass:"spinner-layer spinner-green"},[_c('div',{staticClass:"circle-clipper left"},[_c('div',{staticClass:"circle"})]),_c('div',{staticClass:"gap-patch"},[_c('div',{staticClass:"circle"})]),_c('div',{staticClass:"circle-clipper right"},[_c('div',{staticClass:"circle"})])])]),_vm._v(" "),_c('p',{staticClass:"blinking center-align"},[_vm._v("Cargando")]),_vm._v(" "),_c('p',{staticClass:"center-align"},[_vm._v("Por favor Espere")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 157 */
/***/ (function(module, exports) {

module.exports = {"API_URL":"https://api-rrhh.yaracuy.gob.ve","APP_DEVMOD":true}

/***/ }),
/* 158 */,
/* 159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('layout-public',[_c('div',{staticClass:"card card-login"},[_c('form',{staticClass:"card-stacked",on:{"submit":function($event){$event.preventDefault();return _vm.authenticate($event)}}},[_c('div',{staticClass:"card-content grey lighten-4"},[_c('h3',[_vm._v("Ingresar al Sistema")])]),_vm._v(" "),_c('div',{staticClass:"card-content content-input"},[_c('div',{staticClass:"input-field"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.ci),expression:"form.ci"}],class:{ invalid: _vm.errors.ci },attrs:{"type":"text","id":"ci"},domProps:{"value":(_vm.form.ci)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "ci", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"ci","id":"label-ci"}},[_vm._v("Cedula")]),_vm._v(" "),_vm._l((_vm.errors.ci),function(item,index){return _c('span',{key:index,staticClass:"helper-text helper-text-error",attrs:{"data-success":"right"}},[_vm._v("* "+_vm._s(item))])})],2),_vm._v(" "),_c('div',{staticClass:"input-field"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.password),expression:"form.password"}],class:{ invalid: _vm.errors.password },attrs:{"type":"password","id":"password"},domProps:{"value":(_vm.form.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "password", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"password","id":"label-password"}},[_vm._v("Clave")]),_vm._v(" "),_vm._l((_vm.errors.password),function(item,index){return _c('span',{key:index,staticClass:"helper-text helper-text-error",attrs:{"data-success":"right"}},[_vm._v("* "+_vm._s(item))])})],2)]),_vm._v(" "),_c('div',{staticClass:"card-action"},[_c('button',{staticClass:"btn waves-effect waves-light deep-orange darken-2",attrs:{"type":"submit","name":"action"}},[_vm._v("\n          Ingresar\n          "),_c('i',{staticClass:"material-icons right"},[_vm._v("send")])]),_vm._v(" "),_c('router-link',{staticClass:"btn-flat transparent grey-text text-darken-3 waves-effect",attrs:{"to":{ name: 'register' }}},[_vm._v("Registrarse")])],1)])]),_vm._v(" "),_c('loader',{attrs:{"show":_vm.loaderStatus}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Register_vue__ = __webpack_require__(72);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a6b7631_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Register_vue__ = __webpack_require__(162);
function injectStyle (ssrContext) {
  __webpack_require__(161)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0a6b7631"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Register_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a6b7631_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Register_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 161 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('layout-public',[_c('div',{staticClass:"card card-login"},[_c('form',{staticClass:"card-stacked",on:{"submit":function($event){$event.preventDefault();return _vm.register($event)}}},[_c('div',{staticClass:"card-content grey lighten-4"},[_c('h3',[_vm._v("Registrarse en el Sistema")])]),_vm._v(" "),_c('div',{staticClass:"card-content content-input"},[_c('div',{staticClass:"input-field"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.name),expression:"form.name"}],class:{ invalid: _vm.errors.name },attrs:{"type":"text","id":"name"},domProps:{"value":(_vm.form.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "name", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"name","id":"label-name"}},[_vm._v("Nombre")]),_vm._v(" "),_vm._l((_vm.errors.name),function(item,index){return _c('span',{key:index,staticClass:"helper-text helper-text-error",attrs:{"data-success":"right"}},[_vm._v("* "+_vm._s(item))])})],2),_vm._v(" "),_c('div',{staticClass:"input-field"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.ci),expression:"form.ci"}],class:{ invalid: _vm.errors.ci },attrs:{"type":"text","id":"ci"},domProps:{"value":(_vm.form.ci)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "ci", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"ci","id":"label-ci"}},[_vm._v("Cedula de Identidad")]),_vm._v(" "),_vm._l((_vm.errors.ci),function(item,index){return _c('span',{key:index,staticClass:"helper-text helper-text-error",attrs:{"data-success":"right"}},[_vm._v("* "+_vm._s(item))])})],2),_vm._v(" "),_c('div',{staticClass:"input-field"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.email),expression:"form.email"}],class:{ invalid: _vm.errors.email },attrs:{"type":"email","id":"email"},domProps:{"value":(_vm.form.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "email", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"email","id":"label-email"}},[_vm._v("Correo Electrónico")]),_vm._v(" "),_vm._l((_vm.errors.email),function(item,index){return _c('span',{key:index,staticClass:"helper-text helper-text-error",attrs:{"data-success":"right"}},[_vm._v("* "+_vm._s(item))])})],2),_vm._v(" "),_c('div',{staticClass:"input-field"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.password),expression:"form.password"}],class:{ invalid: _vm.errors.password },attrs:{"type":"password","id":"password"},domProps:{"value":(_vm.form.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "password", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"password","id":"label-password"}},[_vm._v("Clave")]),_vm._v(" "),_vm._l((_vm.errors.password),function(item,index){return _c('span',{key:index,staticClass:"helper-text helper-text-error",attrs:{"data-success":"right"}},[_vm._v("* "+_vm._s(item))])})],2),_vm._v(" "),_c('div',{staticClass:"input-field"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.password_confirmation),expression:"form.password_confirmation"}],class:{ invalid: _vm.errors.password_confirmation },attrs:{"type":"password","id":"password-confirm"},domProps:{"value":(_vm.form.password_confirmation)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "password_confirmation", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"password-confirm","id":"label-password-confirm"}},[_vm._v("Repetir Clave")]),_vm._v(" "),_vm._l((_vm.errors.password_confirmation),function(item,index){return _c('span',{key:index,staticClass:"helper-text helper-text-error",attrs:{"data-success":"right"}},[_vm._v("* "+_vm._s(item))])})],2)]),_vm._v(" "),_c('div',{staticClass:"card-action"},[_c('button',{staticClass:"btn waves-effect waves-light deep-orange darken-2",attrs:{"type":"submit","name":"action"}},[_vm._v("\n          Registrarse\n          "),_c('i',{staticClass:"material-icons right"},[_vm._v("send")])]),_vm._v(" "),_c('router-link',{staticClass:"btn-flat button-back",attrs:{"to":{ name: 'login' }}},[_c('i',{staticClass:"fas fa-arrow-left"}),_vm._v(" Volver")])],1)])]),_vm._v(" "),_c('loader',{attrs:{"show":_vm.loaderStatus}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Recibo_vue__ = __webpack_require__(73);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_204bb424_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Recibo_vue__ = __webpack_require__(165);
function injectStyle (ssrContext) {
  __webpack_require__(164)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-204bb424"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Recibo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_204bb424_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Recibo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 164 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('layout-dashboard',[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('h5',[_vm._v("Generar Recibo de Pago")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s12"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.nomina),expression:"form.nomina"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.form, "nomina", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.nominas),function(item,index){return _c('option',{key:index,domProps:{"value":index}},[_vm._v(_vm._s(item.descripcion))])}),0),_vm._v(" "),_c('label',[_vm._v("Seleccione una nomina")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s12"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.year),expression:"form.year"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.form, "year", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.years),function(item,index){return _c('option',{key:index,domProps:{"value":item}},[_vm._v(_vm._s(item))])}),0),_vm._v(" "),_c('label',[_vm._v("Seleccione una nomina")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s12"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.month),expression:"form.month"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.form, "month", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[(_vm.months == null)?_c('option',{attrs:{"value":"","disabled":"","selected":""}},[_vm._v("No hay meses disponibles")]):_vm._e(),_vm._v(" "),_vm._l((_vm.months),function(item,index){return _c('option',{key:index,domProps:{"value":item.fecha_p_hasta}},[_vm._v(_vm._s(item.month))])})],2),_vm._v(" "),_c('label',[_vm._v("Seleccione un mes")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.sendemail),expression:"form.sendemail"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.form.sendemail)?_vm._i(_vm.form.sendemail,null)>-1:(_vm.form.sendemail)},on:{"change":function($event){var $$a=_vm.form.sendemail,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.form, "sendemail", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.form, "sendemail", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.form, "sendemail", $$c)}}}}),_vm._v(" "),_c('span',[_vm._v("Enviar al correo electrónico el recibo de pago generado")])])])])]),_vm._v(" "),_c('div',{staticClass:"card-action"},[_c('button',{staticClass:"waves-effect waves-light btn",attrs:{"disabled":_vm.button},on:{"click":_vm.generarRecibo}},[_vm._v("Generar recibo de Pago")]),_vm._v(" "),_c('router-link',{staticClass:"btn-flat button-back",attrs:{"to":{ name: 'home' }}},[_c('i',{staticClass:"fas fa-arrow-left"}),_vm._v(" Volver")])],1)]),_vm._v(" "),_c('div',{staticClass:"modal",attrs:{"id":"generar-recibo"}},[_c('div',{staticClass:"modal-content"},[_c('h4',[_vm._v("Desea generar el recibo de pago")])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"modal-close waves-effect waves-green btn-flat"},[_vm._v("Cancelar")]),_vm._v(" "),_c('button',{staticClass:"waves-effect waves-green btn",on:{"click":_vm.generarReciboConfirm}},[_vm._v("Generar")])])]),_vm._v(" "),_c('div',{staticClass:"modal",attrs:{"id":"descargar-recibo"}},[_c('div',{staticClass:"modal-content"},[_c('h4',[_c('i',{staticClass:"fas fa-check"}),_vm._v(" Archivo Generado con éxito")])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('span',{staticClass:"btn-small btn-flat disabled"},[_c('i',{staticClass:"fas fa-file-pdf"}),_vm._v(" "+_vm._s(_vm.recibo.filename)+"\n      ")]),_vm._v(" "),_c('a',{staticClass:"waves-effect waves-green btn",attrs:{"id":"linkdownload"}},[_c('i',{staticClass:"fas fa-download"}),_vm._v(" Descargar Archivo")])])]),_vm._v(" "),_c('loader',{attrs:{"show":_vm.loaderStatus}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Constancia_vue__ = __webpack_require__(74);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_454ccb68_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Constancia_vue__ = __webpack_require__(168);
function injectStyle (ssrContext) {
  __webpack_require__(167)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-454ccb68"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Constancia_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_454ccb68_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Constancia_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 167 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('layout-dashboard',[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('h5',[_vm._v("Generar Constancia de Trabajo")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s12"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.nomina),expression:"form.nomina"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.form, "nomina", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.nominas),function(item,index){return _c('option',{key:index,domProps:{"value":index}},[_vm._v(_vm._s(item.descripcion))])}),0),_vm._v(" "),_c('label',[_vm._v("Seleccione una nomina")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col s12"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.tipo),expression:"form.tipo"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.form, "tipo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"basico"}},[_vm._v("Sueldo Basico")]),_vm._v(" "),_c('option',{attrs:{"value":"integral"}},[_vm._v("Sueldo Integral")])]),_vm._v(" "),_c('label',[_vm._v("Tipo de Constancia")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.sendemail),expression:"form.sendemail"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.form.sendemail)?_vm._i(_vm.form.sendemail,null)>-1:(_vm.form.sendemail)},on:{"change":function($event){var $$a=_vm.form.sendemail,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.form, "sendemail", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.form, "sendemail", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.form, "sendemail", $$c)}}}}),_vm._v(" "),_c('span',[_vm._v("Enviar al correo electrónico la constancia generada")])])])])]),_vm._v(" "),_c('div',{staticClass:"card-action"},[_c('button',{staticClass:"waves-effect waves-light btn",attrs:{"disabled":_vm.button},on:{"click":_vm.generarRecibo}},[_vm._v("Generar recibo de Pago")]),_vm._v(" "),_c('router-link',{staticClass:"btn-flat button-back",attrs:{"to":{ name: 'home' }}},[_c('i',{staticClass:"fas fa-arrow-left"}),_vm._v(" Volver")])],1)]),_vm._v(" "),_c('div',{staticClass:"modal",attrs:{"id":"generar-recibo"}},[_c('div',{staticClass:"modal-content"},[_c('h4',[_vm._v("Desea generar el recibo de pago")])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"modal-close waves-effect waves-green btn-flat"},[_vm._v("Cancelar")]),_vm._v(" "),_c('button',{staticClass:"waves-effect waves-green btn",on:{"click":_vm.generarReciboConfirm}},[_vm._v("Generar")])])]),_vm._v(" "),_c('div',{staticClass:"modal",attrs:{"id":"descargar-recibo"}},[_c('div',{staticClass:"modal-content"},[_c('h4',[_c('i',{staticClass:"fas fa-check"}),_vm._v(" Archivo Generado con éxito")])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('span',{staticClass:"btn-small btn-flat disabled"},[_c('i',{staticClass:"fas fa-file-pdf"}),_vm._v(" "+_vm._s(_vm.constancia.filename)+"\n      ")]),_vm._v(" "),_c('a',{staticClass:"waves-effect waves-green btn",attrs:{"id":"linkdownload"}},[_c('i',{staticClass:"fas fa-download"}),_vm._v(" Descargar Archivo")])])]),_vm._v(" "),_c('loader',{attrs:{"show":_vm.loaderStatus}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_auth__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_materialize_css__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_materialize_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_materialize_css__);






var user = Object(__WEBPACK_IMPORTED_MODULE_3__helpers_auth__["a" /* getLocalUser */])();

/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    count: 12,
    currentUser: user,
    isLoggedIn: !!user,
    loading: false,
    auth_error: null,
    customers: [],
    welcome: 'dfd'
  },
  getters: {
    isLoading: function isLoading(state) {
      return state.loading;
    },
    isLoggedIn: function isLoggedIn(state) {
      return state.isLoggedIn;
    },
    currentUser: function currentUser(state) {
      return state.currentUser;
    },
    authError: function authError(state) {
      return state.auth_error;
    },
    customers: function customers(state) {
      return state.customers;
    }
  },
  mutations: {
    login: function login(state) {
      state.loading = true;
      state.auth_error = null;
    },
    loginSuccess: function loginSuccess(state, payload) {
      state.auth_error = null;
      state.isLoggedIn = true;
      state.loading = false;
      state.currentUser = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, payload.user, {
        token: payload.access_token,
        nomina: payload.nomina
      });
      __WEBPACK_IMPORTED_MODULE_4_materialize_css__["toast"]({ html: '<span>Has <strong>iniciado</strong> sesión con éxito</span>', classes: 'teal lighten-2' });
      localStorage.setItem('user', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(state.currentUser));
    },
    loginFailed: function loginFailed(state, payload) {
      state.loading = false;
      state.auth_error = payload.error.response.data.error;
      __WEBPACK_IMPORTED_MODULE_4_materialize_css__["toast"]({ html: state.auth_error, classes: 'red' });
    },
    logout: function logout(state) {
      localStorage.removeItem('user');
      state.isLoggedIn = false;
      state.currentUser = null;
      __WEBPACK_IMPORTED_MODULE_4_materialize_css__["toast"]({ html: '<span>Has <strong>cerrado</strong> sesión con éxito</span>', classes: 'teal lighten-2' });
    },
    updateCustomers: function updateCustomers(state, payload) {
      state.customers = payload;
    }
  },
  actions: {
    login: function login(context) {
      context.commit('login');
    },
    getCustomers: function getCustomers(context) {
      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('/api/customers').then(function (response) {
        context.commit('updateCustomers', response.data.customers);
      });
    }
  }
});

/***/ })
]),[75]);


// WEBPACK FOOTER //
// static/js/app.2a134d4c4662c13216eb.js